const sessionStorageModule = (() => {
  /**
   * Setzt ein Item in den sessionStorage.
   * @param {string} key - Der Schlüssel, unter dem das Item gespeichert werden soll.
   * @param {*} value - Der Wert, der gespeichert werden soll (kann beliebigen Datentyp haben).
   */
  function setItem(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error(`Error setting item in sessionStorage: ${error}`);
    }
  }

  /**
   * Ruft ein Item aus dem sessionStorage ab.
   * @param {string} key - Der Schlüssel des Items, das abgerufen werden soll.
   * @returns {*} Der gespeicherte Wert oder null, wenn das Item nicht existiert.
   */
  function getItem(key) {
    try {
      const serializedValue = sessionStorage.getItem(key);
      return serializedValue ? JSON.parse(serializedValue) : null;
    } catch (error) {
      console.error(`Error getting item from sessionStorage: ${error}`);
      return null;
    }
  }

  /**
   * Entfernt ein Item aus dem sessionStorage.
   * @param {string} key - Der Schlüssel des Items, das entfernt werden soll.
   */
  function removeItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item from sessionStorage: ${error}`);
    }
  }

  /**
   * Überprüft, ob ein Item im sessionStorage existiert.
   * @param {string} key - Der Schlüssel des Items, das überprüft werden soll.
   * @returns {boolean} true, wenn das Item existiert, ansonsten false.
   */
  function hasItem(key) {
    return sessionStorage.getItem(key) !== null;
  }

  /**
   * Leert den gesamten sessionStorage.
   */
  function clear() {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error(`Error clearing sessionStorage: ${error}`);
    }
  }

  return {
    setItem,
    getItem,
    removeItem,
    hasItem,
    clear
  };
})();

export default sessionStorageModule;
